module.exports = __webpack_public_path__ + "static/media/download_large.364cf8ba.svg";